import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { WebsiteButtonInterface } from 'src/shared/types/entities/website-button-interface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export const createWebsiteButton = (
  parentId: string,
  text: string,
  subText: string,
  masterBlockId?: MasterBlockId,
  action?: ButtonActionTypeEnum,
) => {
  const button: WebsiteButtonInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.WebsiteButton,
      parentId,
      masterBlockId,
    ),
    type: EntityTypeEnum.WebsiteButton,
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    alignSelf: 'center',
    text,
    subText,
    boxShadow: 'none',
    mobileAlignSelf: 'center',
    mobileBoxShadow: 'none',
    margin: {
      marginTop: 25,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
  }

  if (action) {
    button.action = action
  }

  return button
}
